
import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AGBConfirmationDialogResult } from "../../shared/contentTypes";
import { WebShopService } from "../../services/webShop.service";
import { RegisterPrivacyDataResolver } from "../../resolver/RegisterPrivacyDataResolver";

@Component({
  selector: "agbConfirmationDialog",
  templateUrl: "./agbConfirmationDialog.component.html",
  styleUrls: ["./agbConfirmationDialog.component.scss"]
})

export class AGBConfirmationDialogComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;
  public AGB_innerhtml: any = "";

  constructor(
    public bottomSheetRef: MatBottomSheetRef<AGBConfirmationDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: any,
    private _coreLogService: CoreLogService,
    private _webShopService: WebShopService,
    private _internationalisationService: InternationalisationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _domSanitizer: DomSanitizer,
    private _registerPrivacyDataResolver: RegisterPrivacyDataResolver
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("AgbConfirmationDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.setTermAcceptance();
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  private get hasAcceptedAGB(): boolean {
    return this._webShopService.hasAcceptedAGB;
  }

  private set hasAcceptedAGB(accepted: boolean) {
    this._webShopService.hasAcceptedAGB = accepted;
  }

  private async setTermAcceptance(): Promise<void> {
    const me = this;
    try {
      const resolverData = await me._registerPrivacyDataResolver.resolve(null, null);
      if (resolverData && resolverData.settingsViewModel) {
        me.AGB_innerhtml = resolverData.settingsViewModel.register_term_text;
        me.AGB_innerhtml = me._domSanitizer.bypassSecurityTrustHtml(me.AGB_innerhtml);
        me.PushChanges();
      }
    } catch (error) {
      me._coreLogService.error("AGBConfirmationDialog.setTermAcceptance", "resolver failed", error);
    }
  }
  /**
     * Handles clicks on term links within AGB text
     * Closes AGB dialog and signals to open term dialog
     */
  public onShowTermsClick(event: any): void {
    const me = this;
    const target: HTMLElement = event.target;

    if (target.id) {
      const eleIdArray: string[] = target.id.split("-");
      if (eleIdArray.length === 2) {
        const termId: number = +(eleIdArray[eleIdArray.length - 1]);

        if (termId != null && !isNaN(termId)) {
          // Close AGB dialog and signal to open term dialog
          me.bottomSheetRef.dismiss({
            result: AGBConfirmationDialogResult.OpenTerm,
            termId: termId
          });
        }
      }
    }
    event.stopPropagation();
  }



  public ConfirmAgb(): void {
    const me = this;
    me.hasAcceptedAGB = true;
    me.bottomSheetRef.dismiss({
      result: AGBConfirmationDialogResult.Accepted
    });
  }

  public DenyAgb(): void {
    const me = this;
    me.bottomSheetRef.dismiss({
      result: AGBConfirmationDialogResult.Denied
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }
}


